import { useSelector } from "react-redux";
import {
  canUpdateOrganizationAiCredits,
  isEnterprisePowerUser,
} from "util/organizationRoles";

/** True when the logged-in user is EnterpriseCustomers.Admin. */
export function useEnterprisePowerUser() {
  const session = useSelector((state) => state.userReducer);
  return isEnterprisePowerUser(session);
}

/** True when the user may edit org AI credit allowance on the plan page. */
export function useCanUpdateOrganizationAiCredits() {
  const session = useSelector((state) => state.userReducer);
  return canUpdateOrganizationAiCredits(session);
}

export default useEnterprisePowerUser;
